import { render } from "./ChangePasswordForm.vue?vue&type=template&id=2e0441f7&ts=true"
import script from "./ChangePasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./ChangePasswordForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__